import { __awaiter, __generator } from "tslib";
import { fetchFeatureGates } from './fetchFeatureGates';
/**
 * Use this function if you want your new code to be enabled by default,
 * and disabled by a killswitch FeatureGate to be added to ECS later, if needed (if the new code has issues).
 * It calls fetchFeatureGates, and checks for the value returned (result.killswitchGates[killswitchName]).
 * It returns false if the value is false, true otherwise. If we get an error while executing the function, we return false.
 */
export function isCodeBehindKillswitchEnabled(killswitchName) {
    return __awaiter(this, void 0, void 0, function () {
        var featureGates, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchFeatureGates()];
                case 1:
                    featureGates = _a.sent();
                    if (featureGates &&
                        featureGates.result &&
                        featureGates.result.killswitchGates &&
                        featureGates.result.killswitchGates[killswitchName] === false) {
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/, true];
                case 2:
                    error_1 = _a.sent();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=isCodeBehindKillswitchEnabled.js.map